import React, { Children } from 'react';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
const drinkCategories = [{
  name: 'Craft Cocktails',
  items: [{
    name: 'The Red Lounge',
    description: 'Signature blend of premium vodka, hibiscus, and fresh citrus.',
    price: '$18'
  }, {
    name: '14th Street Old Fashioned',
    description: 'Bourbon, spiced demerara, and house bitters.',
    price: '$17'
  }, {
    name: 'Crimson Martini',
    description: 'Gin, pomegranate reduction, and dry vermouth.',
    price: '$18'
  }, {
    name: 'Golden Hour',
    description: 'Tequila, passion fruit, and a touch of chili.',
    price: '$17'
  }]
}, {
  name: 'Spirits & Wine',
  items: [{
    name: 'Premium Cognac Selection',
    description: 'A curated list of Hennessy, Martell, and Rémy Martin.',
    price: 'MKT'
  }, {
    name: 'Champagne Collection',
    description: 'Moët & Chandon, Veuve Clicquot, and Dom Pérignon.',
    price: 'MKT'
  }, {
    name: 'Red & White Wines',
    description: 'Selected vintages from world-renowned vineyards.',
    price: '$14 - $22'
  }]
}];
export function Drink() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <main className="bg-obsidian min-h-screen" data-id="element-172">
      <div className="pt-24 md:pt-28 pb-16 px-6 md:px-8 max-w-7xl mx-auto" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12 md:mb-16" data-id="element-174">
          <h1 className="text-5xl md:text-88xl font-serif text-champagne mb-6" data-id="element-175">
            DRINK
          </h1>
          <p className="text-white/60 font-sans text-xl md:text-2xl max-w-2xl mx-auto" data-id="element-176">
            Sophisticated spirits and masterfully crafted cocktails for the
            discerning palate.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16" data-id="element-177">
          {drinkCategories.map((category, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} data-id="element-178">
              <h2 className="text-sm uppercase tracking-[0.4em] text-champagne mb-8 md:mb-12 border-b border-champagne/20 pb-4" data-id="element-179">
                {category.name}
              </h2>
              <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
            once: true
          }} className="space-y-8 md:space-y-12" data-id="element-180">
                {category.items.map((item, i) => <motion.div key={i} variants={itemVariants} className="group cursor-pointer" data-id="element-181">
                    <div className="flex justify-between items-baseline mb-2" data-id="element-182">
                      <h3 className="text-2xl font-serif text-white group-hover:text-champagne transition-colors duration-300" data-id="element-183">
                        {item.name}
                      </h3>
                      <span className="text-champagne/60 font-sans text-sm tracking-widest group-hover:text-champagne transition-colors duration-300" data-id="element-184">
                        {item.price}
                      </span>
                    </div>
                    <p className="text-white/40 font-sans text-lg leading-relaxed group-hover:text-white/70 transition-colors duration-300" data-id="element-185">
                      {item.description}
                    </p>
                  </motion.div>)}
              </motion.div>
            </motion.div>)}
        </div>
      </div>
      <Footer data-id="element-186" />
    </main>;
}